import React from "react";
import { Card } from "../../../common";
import { ReactComponent as Magnifier } from "../../../../assets/icons/Magnifier.svg";

export const PurchasedCompany = () => {
  return (
    <Card classes="w-full md:col-start-1 md:col-end-10 flex justify-between">
      <div>
        {" "}
        <h3 className="text-left text-f24 text-primary font-bold">
          Acquired Business Profiles
        </h3>
        <p className="text-left text-f16 text-secondarytwo mb-4">
          Claim your collection of purchased business profiles here.
        </p>
      </div>
      <div className="pb-3 flex items-center relative">
        <Magnifier className="absolute mb-3 mx-3 right-0 sm:left-0" />
        <input
          type="text"
          placeholder="Search business"
          className="border-input border w-full bg-inputInterface text-f16 p-2 px-11 mb-3 shadow-search rounded"
        />
      </div>
    </Card>
  );
};
